import { EnvironmentType } from "@app-context/environments/context";
import { useRefCallback } from "@enfusion-ui/hooks";
import {
  Button,
  ControlledTextInput,
  InputLabelControl,
} from "@enfusion-ui/web-components";
import { styled } from "@enfusion-ui/web-core";
import { faPlusCircle, faTrash } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { useFieldArray } from "react-hook-form";

const Container = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: var(--spacing);
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: var(--spacing);
`;

const BtnWrapper = styled.div`
  width: 38px;
  margin: auto 0 0;
  max-width: 630px;
`;

const InputWrapper = styled.div`
  flex: 1;

  @media (max-width: 630px) {
    min-width: 45%;
  }
`;

const getName = (idx: number, field: string) =>
  `customEnvironments[${idx}].${field}`;

const newEntry = { label: "", IDPUrl: "", restAPIUrl: "" } as EnvironmentType;

export const CustomEnvInputs: React.FC<unknown> = () => {
  const { fields, append, remove } = useFieldArray({
    name: "customEnvironments",
  });

  const addEntry = useRefCallback(() => {
    append({ ...newEntry });
  }, []);

  return (
    <>
      <Container style={{ marginBottom: 0 }}>
        <InputWrapper>
          <InputLabelControl label="Name" />
        </InputWrapper>
        <InputWrapper>
          <InputLabelControl label="IDP URL" />
        </InputWrapper>
        <InputWrapper>
          <InputLabelControl label="API URL" />
        </InputWrapper>
        <BtnWrapper></BtnWrapper>
      </Container>

      {fields.map((entry, idx) => {
        return (
          <Container key={entry.label}>
            <InputWrapper>
              <ControlledTextInput hideLabel name={getName(idx, "label")} />
            </InputWrapper>
            <InputWrapper>
              <ControlledTextInput hideLabel name={getName(idx, "IDPUrl")} />
            </InputWrapper>
            <InputWrapper>
              <ControlledTextInput
                hideLabel
                name={getName(idx, "restAPIUrl")}
              />
            </InputWrapper>

            <BtnWrapper>
              <Button
                style={{ height: "38px", minWidth: "36px" }}
                name="remove"
                onClick={() => remove(idx)}
              >
                <FontAwesomeIcon icon={faTrash} size="xs" />
              </Button>
            </BtnWrapper>
          </Container>
        );
      })}
      <Button
        type="button"
        onClick={addEntry}
        icon={faPlusCircle}
        iconPosition="left"
      >
        Add
      </Button>
    </>
  );
};
